import createStore from "astrid-helpers/src/createStore";

import { removeItem } from "../../../utils/localStorage";

import { onUser } from "../../authentication/state/user";

export const [getOrganizationId, setOrganizationId, useOrganizationId, onOrganizationId, resetOrganizationId] =
	createStore();

onOrganizationId((orgId, previousOrgId) => {
	if (previousOrgId) {
		removeItem("calendarFilters");
	}
});

onUser((user, previousUser) => {
	if (previousUser && user?.uid !== previousUser.uid) {
		resetOrganizationId();
	}
});
